<template>
	<picture :id="imageId" class="image" :style="style" :data-loaded="load || isSvg ? 'true' : 'false'">
		<source 
      v-if="!isSvg"
			:data-srcset="srcset"
			:sizes="sizes"
			aria-hidden="true"
		/>
		<img
			class="image__elem"
			:src="initialSrc" 
			:alt="obj.alt" 
      :loading="!load && isLoadingLazy ? 'lazy' : ''"
		/>
	</picture>
</template>

<script setup="props">
  import { computed, toRefs, ref, onMounted, onUpdated } from 'vue';

  const props = defineProps({
		obj: { type: Object,default: () => ({}) },
		widthParam: { type: String, default: 'width' },
		sizes: { type: String, default: '100vw' },
		fit: { type: String, default: 'cover' },
		standard: { type: Boolean, default: true },
		load: { type: Boolean, default: false },
    isLoadingLazy: { type: Boolean, default: false },
  })

  const { obj,widthParam,sizes,fit,standard,load} = toRefs(props)

  const set = ref([100, 116, 134, 156, 182, 210, 244, 282, 328, 380, 442, 512, 594, 688, 798, 926, 1074, 1246, 1446, 1678, 1946, 2258, 2618, 3038])
  const noImage = ref('data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7')

  const isSvg = computed(() => {
    return imgUrl.value.includes('.svg')
  })

  const imageId = computed(() => {
    const num = Math.floor(new Date().valueOf() * Math.random() * 1000)	
		return `image${num}`
  })

  const width = computed(() => {
    return obj.value.width
  })

  const imgUrl = computed(() => {
    return obj.value.url
  })

  const initialSrc = computed(() => {
    if(!isSvg.value && !load.value){
      const url = standard.value ? `${imgUrl.value}&${widthParam.value}=10` : noImage.value
      return url;
    }else{
      return `${imgUrl.value}`
    }  
  })

  const style = computed(() => {
    const h = obj.value.height
    const w = width.value
    return {
      '--maxw': `${w}px`,
      '--maxh': `${h}px`,
      '--aspect-ratio': `var(--ov-aspect-ratio, ${h/w})`, 
      '--image-fit': fit.value
    }
  })

  const srcset = computed(() => {
    if(!standard.value) return imgUrl.value;

    const w = width.value
    const url = imgUrl.value
    const wp = widthParam.value;
    let a = false
    
    return set.value.reduce((newSizes, size) => {
      if(a) return newSizes;
      if(size <= w) {
        newSizes.push(`${url}&${wp}=${size} ${size}w`)
      }else {
        newSizes.push(`${url}&${wp}=${w} ${w}w`);
        a = true
      }
      return newSizes;
    }, [])
  })

  onMounted(() => {
    lazyLoadImg(false);
  })

  // onUpdated(() => {
  //   lazyLoadImg(true)
  // })

  const lazyLoadImg = (dataset) => {
    if(load.value) return;
    const el = document.querySelector(`#${imageId.value}`);
		if(el && window.lazyImageFn && !isSvg.value){
      dataset && (el.dataset.loaded = false);
      window.lazyImageFn(el);
    }
  }
</script>